/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {FC} from 'react'
import {useLayout} from '../../core'
import {DefaultTitle} from '../header/page-title/DefaultTitle'

const Toolbar1: FC = () => {
  const {classes} = useLayout()

  return (
    <div className='toolbar' id='kt_toolbar'>
      {/* begin::Container */}
      <div
        id='kt_toolbar_container'
        className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack position-relative')}
      >
        <DefaultTitle />

        {/* begin::Slot para contenido centrado inyectado por la página (ej. fecha administrativa) */}
        <div
          id='kt_toolbar_center_slot'
          className='position-absolute top-50 start-50 translate-middle d-flex align-items-center'
        ></div>
        {/* end::Slot centrado */}

        {/* begin::Actions */}
        <div className='d-flex align-items-center py-1'>
          {/* begin::Slot para acciones/botones inyectados por la página */}
          <div id='kt_toolbar_actions_slot' className='d-flex align-items-center'></div>
          {/* end::Slot de acciones */}
        </div>
        {/* end::Actions */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export {Toolbar1}
